import React, { useRef, useEffect } from 'react';

const WaveformDisplay = ({ analyzerNode, isActive }) => {
  const canvasRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    const drawWaveform = () => {
      if (!analyzerNode || !isActive) {
        // Clear canvas when not active
        ctx.clearRect(0, 0, width, height);
        return;
      }

      // Get waveform data
      const bufferLength = analyzerNode.frequencyBinCount;
      const dataArray = new Float32Array(bufferLength);
      analyzerNode.getFloatTimeDomainData(dataArray);

      // Clear canvas
      ctx.fillStyle = '#f5f5f5';
      ctx.fillRect(0, 0, width, height);

      // Draw waveform
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#4CAF50';

      const sliceWidth = width / bufferLength;
      let x = 0;

      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i];
        const y = (v + 1) * height / 2;

        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      ctx.lineTo(width, height / 2);
      ctx.stroke();

      animationFrameRef.current = requestAnimationFrame(drawWaveform);
    };

    if (isActive) {
      drawWaveform();
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [analyzerNode, isActive]);

  return (
    <canvas
      ref={canvasRef}
      width={300}
      height={100}
      style={{
        width: '100%',
        height: '100px',
        borderRadius: '8px',
        backgroundColor: '#f5f5f5'
      }}
    />
  );
};

export default WaveformDisplay; 